import { tv } from '@change/ds-utils';

export const HeaderStyles = tv({
	base: 'flex flex-col gap-2 bg-[#403A49] py-2',
	variants: {
		size: {
			small: 'gap-1 py-1',
			medium: '',
			large: '',
		},
	},
});

export const StoryHeaderStyles = tv({
	base: 'self-start',
	variants: {
		size: {
			small: 'h-2.5 px-[5px]',
			medium: 'h-5 px-2.5',
			large: 'h-6 px-3',
		},
	},
});

export const StoryStepperStyles = tv({
	base: 'h-[2px]',
	variants: {
		size: {
			small: 'h-[1px] px-[7px]',
			medium: 'px-[11px]',
			large: 'px-[6.5px]',
		},
	},
});
